export const AdminMessagesRoutes: IAdminMessageRoute[] = [
    {
        buttonText: "Усе",
        buttonValue:""
    },
    {
        buttonText: "Матеріальна допомога",
        buttonValue:"Матеріальна допомога"
    },
    {
        buttonText: "Запитання",
        buttonValue:"Запитання"
    },
    {
        buttonText: "Заявки у команду",
        buttonValue:"Заявки у команду"
    },
    {
        buttonText: "Заявки на адопцію",
        buttonValue:"Заявки на адопцію"
    }
]